<div class="field" style="display: flex; width: 100%;">

  <app-confirm-delete-product-part [(display)]="openPasswordSetDialog"
                                   [typeConfirmation]="true"
                                   [confirmText]="userPasswordText"
                                   header="Установите пароль пользователя"
                                   messageText="Установите временный пароль пользователя, после первого входа его необходимо сменить!"
                                   (done)="onUserPasswordSet($event)"
                                   *ngIf="enablePasswordDialog">
  </app-confirm-delete-product-part>

  <label *ngIf="showLabel" for="keycloakUserSelector" class="do-not-wrap-text">{{labelKey}}</label>
  <div class="p-inputgroup">
        <p-dropdown #keycloakUserSelector
                    id="keycloakUserSelector"
                    editable="false"
                    class="p-dropdown-filter"
                    [style]="{'flex': '0.35', 'min-width': '0'}"
                    [placeholder]="placeholder"
                    filterPlaceholder="Поиск..."
                    [(ngModel)]="selectedKcUser"
                    [options]="keycloakUsers"
                    optionDisabled="disabled"
                    [filter]="true"
                    [disabled]="_disabled"
                    [virtualScrollItemSize]="31"
                    [virtualScroll]="true"
                    (onChange)="onChangeUser($event)"
                    (onClick)="onClickUser($event)" appendTo="body">

          <ng-template pTemplate="selectedItem">
            <div class="flex align-items-center gap-2" *ngIf="selectedKcUser">
              <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{selectedKcUser.id}} ({{selectedKcUser.username}})</div>
            </div>
          </ng-template>
          <ng-template let-user pTemplate="item">
            <div class="flex align-items-left gap-2">
              <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{user.username}} ({{user.lastName}} {{user.firstName}})</div>
            </div>
          </ng-template>
        </p-dropdown>
      <p-button icon="pi pi-plus" styleClass="p-button-success ml-1" (onClick)="onUserAddButton($event)" [disabled]="thisLoginExists || selectedKcUser"
                pTooltip="Добавить нового пользователя {{userExists}}" tooltipPosition="top" *ngIf="doShowAddUserButton"></p-button>

      <p-button icon="pi pi-sync" styleClass="p-button-success ml-1" (onClick)="onUpdateUserButton($event)" [disabled]="!userExists"
                pTooltip="Обновить логин пользователя" tooltipPosition="top" *ngIf="showUpdateUserButton"></p-button>

      <p-button icon="pi pi-lock" styleClass="p-button-success ml-1" (onClick)="onPasswordSetButton($event)" [disabled]="!userExists"
                pTooltip="Сбросить/установить пароль пользователя" tooltipPosition="top" *ngIf="showPasswordSetButton"></p-button>
  </div>
</div>
